<ng-container *ngIf="loading">
  <div class="homepage-skeleton">
    <div class="skeleton-banner">
      <ngx-skeleton-loader [theme]="{ width: '100%', height: '360px', 'border-radius': '12px' }"
        count="1"></ngx-skeleton-loader>
    </div>

    <div class="skeleton-section">
      <div class="skeleton-header">
        <ngx-skeleton-loader [theme]="{ width: '260px', height: '32px', 'border-radius': '8px' }"
          count="1"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ width: '110px', height: '40px', 'border-radius': '8px' }"
          count="1"></ngx-skeleton-loader>
      </div>
      <div class="skeleton-card-grid skeleton-card-grid--four">
        <ngx-skeleton-loader *ngFor="let _ of length(8)"
          [theme]="{ width: '100%', height: '245px', 'border-radius': '16px' }" count="1"></ngx-skeleton-loader>
      </div>
    </div>

    <div class="skeleton-section">
      <div class="skeleton-header">
        <ngx-skeleton-loader [theme]="{ width: '280px', height: '32px', 'border-radius': '8px' }"
          count="1"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ width: '110px', height: '40px', 'border-radius': '8px' }"
          count="1"></ngx-skeleton-loader>
      </div>
      <div class="skeleton-card-grid skeleton-card-grid--three">
        <ngx-skeleton-loader *ngFor="let _ of length(6)"
          [theme]="{ width: '100%', height: '450px', 'border-radius': '20px' }" count="1"></ngx-skeleton-loader>
      </div>
    </div>

    <div class="skeleton-section">
      <div class="skeleton-header">
        <ngx-skeleton-loader [theme]="{ width: '300px', height: '32px', 'border-radius': '8px' }"
          count="1"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{ width: '110px', height: '40px', 'border-radius': '8px' }"
          count="1"></ngx-skeleton-loader>
      </div>
      <div class="skeleton-card-grid skeleton-card-grid--four">
        <ngx-skeleton-loader *ngFor="let _ of length(8)"
          [theme]="{ width: '100%', height: '220px', 'border-radius': '20px' }" count="1"></ngx-skeleton-loader>
      </div>
    </div>

    <div class="skeleton-section">
      <div class="skeleton-header">
        <ngx-skeleton-loader [theme]="{ width: '320px', height: '32px', 'border-radius': '8px' }"
          count="1"></ngx-skeleton-loader>
      </div>
      <div class="skeleton-feature-grid">
        <ngx-skeleton-loader *ngFor="let _ of length(4)"
          [theme]="{ width: '100%', height: '160px', 'border-radius': '16px' }" count="1"></ngx-skeleton-loader>
      </div>
    </div>

    <div class="skeleton-section">
      <div class="skeleton-header">
        <ngx-skeleton-loader [theme]="{ width: '260px', height: '32px', 'border-radius': '8px' }"
          count="1"></ngx-skeleton-loader>
      </div>
      <div class="skeleton-newsletter">
        <ngx-skeleton-loader [theme]="{ width: '60%', height: '24px', 'border-radius': '6px' }"
          count="1"></ngx-skeleton-loader>
        <div class="skeleton-newsletter-form">
          <ngx-skeleton-loader [theme]="{ width: '65%', height: '48px', 'border-radius': '8px' }"
            count="1"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ width: '160px', height: '48px', 'border-radius': '8px' }"
            count="1"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!loading">
  <div class="home-hero-wrapper">
    <!-- <div class="container remove-top-margin"> -->
    <div id="carouselExampleControls" class="carousel slide reponseivDiv480px home-banner" data-ride="carousel"
      data-interval="5000">
      <div class="carousel-inner main">
        <ng-container *ngIf="BannerListArray?.length">
          <a href="#" *ngFor="let item of BannerListArray; let i = index" class="carousel-item">
            <img class="d-block w-100 tractor" [hidden]="!isLoaded[i]" (load)="onBannerLaod(i)"
              [src]="item?.bannerImage" [attr.loading]="'eager'" [attr.fetchpriority]="'high'" [attr.decoding]="'async'"
              alt="{{ item?.bannerName }}" />
            <!-- Hero Text Overlay -->
            <div class="hero-text-overlay">
              <h1 class="hero-heading">
                <span class="hero-line-1">Shop Smart On EXOBE.</span>
                <span class="hero-line-2">Shop Stylish.</span>
              </h1>
              <div class="hero-description">
                <p class="hero-desc-line-1">Discover premium fashion picks curated for modern.</p>
                <p class="hero-desc-line-2">Top-quality brands. Fresh arrivals.</p>
                <p class="hero-desc-line-3">Experience shopping with confidence.</p>
              </div>
              <div class="hero-buttons">
                <a class="hero-btn shop-now-btn" routerLink="/customer-product-list">
                  Shop Now
                  <i class="fa fa-arrow-right"></i>
                </a>
                <a class="hero-btn browse-categories-btn" routerLink="/customer-category-list">
                  Browse Categories
                </a>
              </div>
            </div>
            <ngx-skeleton-loader *ngIf="!isLoaded[i]" [theme]="{ width: '100%', height: '360px', position: 'relative' }"
              count="1"></ngx-skeleton-loader>
          </a>
        </ng-container>
        <ng-container *ngIf="!BannerListArray?.length && !loading">
          <div *ngFor="let item of length(1)">
            <ngx-skeleton-loader [theme]="{ width: '100%', height: '360px', position: 'relative' }"
              count="1"></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>

      <!-- Carousel Navigation Controls -->
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true">
          <i class="fa fa-chevron-left"></i>
        </span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true">
          <i class="fa fa-chevron-right"></i>
        </span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <!-- Shop by Category Section -->
    <section class="shop-by-category" *ngIf="categoryListArray?.length">
      <div class="container">
        <div class="section-header">
          <div class="header-text">
            <h2 class="section-title"><span class="title-underline">Shop by Category</span></h2>
            <p class="section-subtitle">Find exactly what you're looking for</p>
          </div>
          <button class="see-all-btn" routerLink="/customer-category-list">
            SEE ALL
          </button>
        </div>
        <div class="category-grid">
          <div class="category-card" *ngFor="let item of categoryListArray; let i = index"
            (click)="navigateToViewProducts(item?._id, item?.categoryName)">
            <div class="category-icon">
              <ngx-skeleton-loader *ngIf="!item?.isLoaded && item?.categoryImage"
                [theme]="{ height: '130px', width: '130px', 'border-radius': '12px' }" count="1"></ngx-skeleton-loader>
              <img *ngIf="item?.categoryImage" [src]="item?.categoryImage"
                [ngClass]="{'img-visible': item?.isLoaded, 'img-hidden': !item?.isLoaded}" (load)="onImageLaod(item)"
                (error)="onImageError($event, item)" loading="lazy" decoding="async" alt="{{ item?.categoryName }}" />
              <div *ngIf="!item?.categoryImage" class="category-placeholder" aria-hidden="true"></div>
            </div>
            <h3 class="category-name">{{ item?.categoryName }}</h3>
            <p class="category-count">{{ categoryCounts[item?._id] || 0 }} Products</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Featured Products Section -->
    <section class="featured-products" *ngIf="bannerData?.length">
      <div class="container">
        <div class="section-header">
          <div class="header-text">
            <h2 class="section-title"><span class="title-underline">Featured Products</span></h2>
            <p class="section-subtitle">Handpicked products just for you</p>
          </div>
          <button class="see-all-btn" routerLink="/customer-product-list">
            SEE ALL
          </button>
        </div>
        <div class="products-grid">
          <div class="product-card" *ngFor="let data of bannerData; let i = index"
            (click)="navigateToViewProduct(data?._id, data?.productName)">
            <div class="product-image" *ngIf="data?.thumbnail">
              <img [src]="data?.thumbnail" (load)="onImageLaod(data)" (error)="onImageError($event, data)"
                loading="eager" [attr.fetchpriority]="i < 4 ? 'high' : i < 8 ? 'auto' : 'low'" decoding="async"
                alt="{{ data?.productName }}" />
              <div class="discount-badge" *ngIf="data?.isDealActive">
                {{ data?.dealDiscount }}% OFF
              </div>
              <button class="wishlist-btn" (click)="toggleFeaturedWishlist($event, data)" [class.active]="data?.isLike">
                <i class="fa" [ngClass]="data?.isLike ? 'fa-heart' : 'fa-heart-o'" aria-hidden="true"></i>
              </button>
            </div>
            <div class="product-info">
              <h3 class="product-name">{{ commonService.splitString(data?.productName) }}</h3>
              <p class="product-description" *ngIf="data?.description">
                {{ data?.description | slice:0:80 }}...
              </p>
              <div class="price-section">
                <span class="current-price">
                  <span *ngIf="data?.isDealActive == false">
                    {{ getPrice(data?.priceSizeDetails[0]?.price | currency : "ZAR" : "R") }}
                  </span>
                  <span *ngIf="data?.isDealActive == true">
                    {{ getPrice(getDealPrice(data?.priceSizeDetails[data?.priceSizeDetails.length - 1]?.price,
                    data?.dealDiscount) | currency : "ZAR" : "R") }}
                  </span>
                </span>
                <span class="original-price" *ngIf="data?.isDealActive">
                  {{ getPrice(data?.priceSizeDetails[data?.priceSizeDetails.length - 1]?.price | currency : "ZAR" : "R")
                  }}
                </span>
              </div>
              <div class="cta-row">
                <button class="add-to-cart-btn">
                  <i class="fa fa-shopping-cart"></i>
                  ADD TO CART
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Booking Category Section -->
    <section class="booking-category" *ngIf="serviceData?.length">
      <div class="container">
        <div class="section-header">
          <div class="header-text">
            <h2 class="section-title"><span class="title-underline">BOOKING CATEGORY</span></h2>
            <p class="section-subtitle">Render Our Services At Your Doorsteps</p>
          </div>
          <button class="see-all-btn" routerLink="/customer-service-list">
            SEE ALL
          </button>
        </div>
        <div class="services-grid">
          <div class="service-card" *ngFor="let data of serviceData; let i = index"
            (click)="navigateToViewService(data?._id, data?.categoryName, data?.description)">
            <div class="service-icon" *ngIf="data?.categoryImage">
              <ngx-skeleton-loader *ngIf="!data?.isLoaded" [theme]="{
                height: '280px',
                width: '100%',
                'border-radius': '16px',
                background: 'linear-gradient(90deg, #f4f5f7 0%, #e6e8ec 50%, #f4f5f7 100%)'
              }" count="1"></ngx-skeleton-loader>
              <img [src]="data?.categoryImage" [class.image-loaded]="data?.isLoaded"
                [class.image-loading]="!data?.isLoaded" (load)="onImageLaod(data)" loading="lazy" decoding="async"
                alt="{{ data?.categoryName }}" />
            </div>
            <div *ngIf="!data?.categoryImage" class="service-placeholder" aria-hidden="true"></div>
            <h3 class="service-name">{{ commonService.splitString(data?.categoryName) }}</h3>
            <p class="service-description" *ngIf="data?.description">{{ data?.description | slice:0:50 }}...</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Feature Highlights Section -->
    <section class="feature-highlights">
      <div class="container">
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fa fa-truck" aria-hidden="true"></i>
            </div>
            <h3 class="feature-title">Free Shipping</h3>
            <p class="feature-description">Free delivery on orders over R500</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fa fa-refresh" aria-hidden="true"></i>
            </div>
            <h3 class="feature-title">Easy Returns</h3>
            <p class="feature-description">30-day return policy</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fa fa-shield" aria-hidden="true"></i>
            </div>
            <h3 class="feature-title">Secure Payment</h3>
            <p class="feature-description">100% secure checkout</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fa fa-headphones" aria-hidden="true"></i>
            </div>
            <h3 class="feature-title">24/7 Support</h3>
            <p class="feature-description">Round the clock customer service</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Newsletter Section -->
    <section class="newsletter-section">
      <div class="container">
        <div class="newsletter-content">
          <h2 class="newsletter-title">Stay Updated</h2>
          <p class="newsletter-subtitle">Subscribe to our newsletter for the latest deals and updates</p>
          <div class="newsletter-form">
            <input type="email" class="newsletter-input" placeholder="Enter your email address" [(ngModel)]="emailN"
              maxlength="50" (keypress)="preventSpace($event)">
            <button class="newsletter-btn" [disabled]="isEmailValid()" (click)="getDeals()">SUBSCRIBE</button>
          </div>
        </div>
      </div>
    </section>

    <div class="container remove-top-margin home-section home-recommendations-hidden">
      <!-- <div
      id="carouselExampleControls"
      class="carousel slide reponseivDiv480px"
      data-ride="carousel"
    >
      <div class="carousel-inner main">
        <ng-container *ngIf="BannerListArray?.length">
          <a
            href="#"
            *ngFor="let item of BannerListArray; let i = index"
            class="carousel-item"
            [ngClass]="{ active: i == 0 }"
          >
            <img
              class="d-block w-100 tractor"
              [hidden]="!isLoaded[i]"
              (load)="onBannerLaod(i)"
              src="{{ item?.bannerImage }}"
              alt="{{ item?.bannerName }}"
            />
            <ngx-skeleton-loader
              *ngIf="!isLoaded[i]"
              [theme]="{ width: '100%', height: '360px', position: 'relative' }"
              count="1"
            ></ngx-skeleton-loader>
          </a>
        </ng-container>
        <ng-container *ngIf="!BannerListArray?.length && !loading">
          <div *ngFor="let item of length(1)">
            <ngx-skeleton-loader
              [theme]="{ width: '100%', height: '360px', position: 'relative' }"
              count="1"
            ></ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>

      <div class="carousel-indicators" style="bottom: -20px !important">
        <ng-container *ngFor="let item of BannerListArray; let i = index">
          <button
            type="button"
            [attr.data-target]="'#carouselExampleControls'"
            [attr.data-slide-to]="i"
            [ngClass]="{ active: i == 0 }"
          ></button>
        </ng-container>
      </div>
    </div> -->

      <!-- 14/4/2025 Tabish  -->
      <!--Personalized Recommendations Section-->
      <!-- <div class="shopBox mt-5" style="width: 100%; max-width: 1440px; margin: auto; padding: 50px 0px"
      *ngIf="recommendedData?.length"> -->
      <div class="shopBox shopBox--fullwidth" *ngIf="recommendedData?.length">
        <div class="d-flex justify-content-between align-items-center heading-wrap">
          <h1 class="heading-text-cat">
            <!-- <img src="assets/latest/left-arrow.svg" alt="" class="leftImage" /> -->
            PERSONALIZED RECOMMENDATIONS
            <!-- <img src="assets/latest/right-arrow.svg" alt="" class="rightImage" /> -->
          </h1>
          <button class="see-All see-All--link" type="button" (click)="setRecomend()">
            See All
          </button>
        </div>
        <div class="items mt-4">
          <div class="slick_slider">
            <div class="banner_slider slider slider-customize">
              <div *ngFor="let data of recommendedData; let i = index">
                <div *ngIf="data?.thumbnail">
                  <div class="bannerContent">
                    <div class="card innerDiv" (click)="
                      navigateToViewProduct(data?._id, data?.productName)
                    ">
                      <div class="image">
                        <img class="img" [hidden]="!data?.isLoaded" (load)="onImageLaod(data)" [src]="data?.thumbnail"
                          loading="lazy" decoding="async" alt="categoryImage" />
                        <ngx-skeleton-loader *ngIf="!data?.isLoaded" [theme]="{
                          width: '227px',
                          height: '329px',
                          position: 'relative',
                          margin: '0 10px 0px 0px'
                        }" count="1"></ngx-skeleton-loader>
                      </div>

                      <div class="product-desc">
                        <!-- <p class="description">
                          {{ commonService.splitString(data?.productName) }}
                            Nike
                        </p> -->
                        <p>
                          {{ commonService.splitString(data?.productName) }}
                        </p>
                        <div class="row" *ngIf="data?.isDealActive == true">
                          <div class="col-12 p-0 m-0">
                            <p class="price description">
                              <span class="strikethrough">
                                {{
                                data?.priceSizeDetails[
                                data?.priceSizeDetails.length - 1
                                ]?.price &&
                                getPrice(
                                data?.priceSizeDetails[
                                data?.priceSizeDetails.length - 1
                                ]?.price | currency : "ZAR" : "R"
                                )
                                }}
                              </span>
                              <span class="price-color ml-0">{{
                                data?.dealPrice &&
                                getPrice(
                                getDealPrice(
                                data?.priceSizeDetails[
                                data?.priceSizeDetails.length - 1
                                ]?.price,
                                data?.dealDiscount
                                ) | currency : "ZAR" : "R"
                                )
                                }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="row" *ngIf="data?.isDealActive == false">
                          <div class="col-12 p-0 m-0">
                            <p class="price description">
                              <span>
                                {{
                                data?.priceSizeDetails[0]?.price &&
                                getPrice(
                                data?.priceSizeDetails[0]?.price
                                | currency : "ZAR" : "R"
                                )
                                }}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="row price-row" *ngIf="data?.isDealActive == true">
                          <div class="col-12 p-0 m-0" *ngIf="data?.discount >= 0">
                            <p class="dealPrice">
                              Discount :
                              <span class="newn">
                                {{ data?.dealDiscount }}% off
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="mt-3">
                      <p class="description">
                        {{ commonService.splitString(data?.productName) }}
                      </p>
                    </div> -->
                      <!-- <div class="mt-3">
                      <p class="description">
                        {{ commonService.splitString(data?.productName) }}
                      </p>
                    </div> -->
                      <!-- <div style="margin-top: -8px">
                      <div class="row" *ngIf="data?.isDealActive == true">
                        <div class="col-12 p-0 m-0">
                          <p class="price">
                            <span class="strikethrough">
                              {{
                              data?.priceSizeDetails[data?.priceSizeDetails.length - 1]?.price &&
                              getPrice(
                              data?.priceSizeDetails[data?.priceSizeDetails.length - 1]?.price
                              | currency : "ZAR" : "R"
                              )
                              }}
                            </span>
                            <span class="price-color ml-0">{{
                              data?.dealPrice &&
                              getPrice(
                              getDealPrice(data?.priceSizeDetails[data?.priceSizeDetails.length -
                              1]?.price,data?.dealDiscount ) | currency : "ZAR" : "R"
                              )
                              }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="row" *ngIf="data?.isDealActive == false">
                        <div class="col-12 p-0 m-0">
                          <p class="price">
                            <span>
                              {{
                              data?.priceSizeDetails[0]?.price &&
                              getPrice(
                              data?.priceSizeDetails[0]?.price
                              | currency : "ZAR" : "R"
                              )
                              }}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="row" style="margin-top: -8px" *ngIf="data?.isDealActive == true">
                        <div class="col-12 p-0 m-0" *ngIf="data?.discount >= 0">
                          <p class="dealPrice">
                            Discount :
                            <span class="newn">
                              {{ data?.dealDiscount }}% off
                            </span>
                          </p>
                        </div>
                      </div>
                    </div> -->
                    </div>
                  </div>
                </div>
                <div *ngIf="!data?.thumbnail">
                  <div class="bannerContent d-flex justify-content-between">
                    <ngx-skeleton-loader *ngFor="let item of length(5)" [theme]="{
                      width: '227px',
                      height: '329px',
                      position: 'relative',
                      margin: '0 10px 0px 0px'
                    }" count="1">
                    </ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="shopBox" style="max-width: 1440px; margin: auto; padding: 0px 0px 50px;margin-top: 0px !important;"
      *ngIf="categoryListArray?.length" style="margin-top: 100px"> -->
      <!-- <div class="shopBox" style="max-width: 1440px; margin: auto; padding: 0px 0px 50px;margin-top: 0px !important;"
      *ngIf="categoryListArray?.length" style="margin-top: 20px"> -->
      <div class="shopBox shopBox-legacy" *ngIf="categoryListArray?.length">
        <ngx-slick-carousel class="carousel" [config]="sliderConfig">
          <div class="d-flex justify-content-between heading-wrap heading-wrap-centered">
            <h1 class="heading-text-cat">
              <!-- <img src="assets/latest/left-arrow.svg" alt="" class="leftImage" /> -->
              SHOP BY CATEGORY
              <!-- <img src="assets/latest/right-arrow.svg" alt="" class="rightImage" /> -->
            </h1>
            <span routerLink="/customer-category-list" class="cursor-pointer">
              <p class="see-All">See All</p>
            </span>
          </div>
        </ngx-slick-carousel>
        <div class="d-flex mt-4 shopSliderimg">
          <div class="col-md-2 col-lg-2 col-sm-1 p-0" *ngFor="let item of categoryListArray">
            <div class="uuu cursor-pointer" *ngIf="item?.categoryImage"
              (click)="navigateToViewProducts(item?._id, item?.categoryName)">
              <img [src]="item?.categoryImage" [hidden]="!item?.isLoaded" (load)="onImageLaod(item)" loading="lazy"
                decoding="async" alt="" />
              <ngx-skeleton-loader *ngIf="!item?.isLoaded" [theme]="{ height: '140px' }" count="1">
              </ngx-skeleton-loader>
              <p class="d text-center shopbottomText">
                {{ item?.categoryName }}
              </p>
            </div>
            <div class="uuu">
              <ngx-skeleton-loader *ngIf="!item?.categoryImage && !item?.isLoaded" [theme]="{ height: '140px' }"
                count="1"></ngx-skeleton-loader>
            </div>
          </div>
        </div>
      </div>

      <!-- product slider -->
      <!-- <div class="container pb-3 productBox" *ngIf="bannerData?.length" style="margin-top: 70px;"> -->
      <div class="pd-0 featured-products-carousel" *ngIf="bannerData?.length">
        <div class="d-flex justify-content-between heading-wrap heading-wrap--centered">
          <h1 class="heading-text-cat">
            <!-- <img src="assets/latest/left-arrow.svg" alt="" class="leftImage" /> -->
            PRODUCTS
            <!-- <img src="assets/latest/right-arrow.svg" alt="" class="rightImage" /> -->
          </h1>
          <button class="see-All see-All--link" type="button" routerLink="/customer-product-list">
            See All
          </button>
        </div>
        <div class="items mt-4">
          <div class="slick_slider">
            <div class="banner_slider slider slider-customize">
              <div *ngFor="let data of bannerData; let i = index">
                <div *ngIf="data?.thumbnail">
                  <div class="bannerContent">
                    <div class="card innerDiv" (click)="
                      navigateToViewProduct(data?._id, data?.productName)
                    ">
                      <div class="image">
                        <img class="img" [hidden]="!data?.isLoaded" (load)="onImageLaod(data)" [src]="data?.thumbnail"
                          loading="lazy" decoding="async" alt="categoryImage" />
                        <ngx-skeleton-loader *ngIf="!data?.isLoaded" [theme]="{
                          width: '227px',
                          height: '329px',
                          position: 'relative',
                          margin: '0 10px 0px 0px'
                        }" count="1"></ngx-skeleton-loader>
                      </div>

                      <div class="product-desc">
                        <!-- <p class="description">
                          {{ commonService.splitString(data?.productName) }}
                            Nike
                        </p> -->
                        <p>
                          {{ commonService.splitString(data?.productName) }}
                        </p>
                        <div>
                          <div class="row" *ngIf="data?.isDealActive == true">
                            <div class="col-12 p-0 m-0">
                              <p class="price description">
                                <span class="strikethrough">
                                  {{
                                  data?.priceSizeDetails[
                                  data?.priceSizeDetails.length - 1
                                  ]?.price &&
                                  getPrice(
                                  data?.priceSizeDetails[
                                  data?.priceSizeDetails.length - 1
                                  ]?.price | currency : "ZAR" : "R"
                                  )
                                  }}
                                </span>
                                <span class="price-color ml-0">{{
                                  data?.dealPrice &&
                                  getPrice(
                                  getDealPrice(
                                  data?.priceSizeDetails[
                                  data?.priceSizeDetails.length - 1
                                  ]?.price,
                                  data?.dealDiscount
                                  ) | currency : "ZAR" : "R"
                                  )
                                  }}</span>
                              </p>
                            </div>
                          </div>
                          <div class="row" *ngIf="data?.isDealActive == false">
                            <div class="col-12 p-0 m-0">
                              <p class="price description">
                                <span>
                                  {{
                                  data?.priceSizeDetails[0]?.price &&
                                  getPrice(
                                  data?.priceSizeDetails[0]?.price
                                  | currency : "ZAR" : "R"
                                  )
                                  }}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div class="row price-row" *ngIf="data?.isDealActive == true">
                            <div class="col-12 p-0 m-0" *ngIf="data?.discount >= 0">
                              <p class="dealPrice">
                                Discount :
                                <span class="newn">
                                  {{ data?.dealDiscount }}% off
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="mt-3">
                      <p class="description">
                        {{ commonService.splitString(data?.productName) }}
                      </p>
                    </div>
                    <div style="margin-top: -8px">
                      <div class="row" *ngIf="data?.isDealActive == true">
                        <div class="col-12 p-0 m-0">
                          <p class="price">
                            <span class="strikethrough">
                              {{
                              data?.priceSizeDetails[data?.priceSizeDetails.length - 1]?.price &&
                              getPrice(
                              data?.priceSizeDetails[data?.priceSizeDetails.length - 1]?.price
                              | currency : "ZAR" : "R"
                              )
                              }}
                            </span>
                            <span class="price-color ml-0">{{
                              data?.dealPrice &&
                              getPrice(
                              getDealPrice(data?.priceSizeDetails[data?.priceSizeDetails.length -
                              1]?.price,data?.dealDiscount ) | currency : "ZAR" : "R"
                              )
                              }}</span>
                          </p>
                        </div>
                      </div>
                      <div class="row" *ngIf="data?.isDealActive == false">
                        <div class="col-12 p-0 m-0">
                          <p class="price">
                            <span>
                              {{
                              data?.priceSizeDetails[0]?.price &&
                              getPrice(
                              data?.priceSizeDetails[0]?.price
                              | currency : "ZAR" : "R"
                              )
                              }}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="row" style="margin-top: -8px" *ngIf="data?.isDealActive == true">
                        <div class="col-12 p-0 m-0" *ngIf="data?.discount >= 0">
                          <p class="dealPrice">
                            Discount :
                            <span class="newn">
                              {{ data?.dealDiscount }}% off
                            </span>
                          </p>
                        </div>
                      </div>
                    </div> -->
                    </div>
                  </div>
                </div>
                <div *ngIf="!data?.thumbnail">
                  <div class="bannerContent d-flex justify-content-between">
                    <ngx-skeleton-loader *ngFor="let item of length(5)" [theme]="{
                      width: '227px',
                      height: '329px',
                      position: 'relative',
                      margin: '0 10px 0px 0px'
                    }" count="1">
                    </ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- deal slider -->
      <div class="container pb-3 deals-container" *ngIf="serviceDetail?.length">
        <div class="d-flex justify-content-between heading-wrap heading-wrap-centered">
          <h1 class="heading-text-cat">
            <!-- <img src="assets/latest/left-arrow.svg" alt="" class="leftImage" /> -->
            DEALS ON PRODUCTS
            <!-- <img src="assets/latest/right-arrow.svg" alt="" class="rightImage" /> -->
          </h1>
          <span routerLink="/customer-product-deal-list" class="cursor-pointer">
            <p class="see-All">See All</p>
          </span>
        </div>
        <div class="items mt-4">
          <div class="slick_slider">
            <div class="deal_slider slider slider-customize">
              <div *ngFor="let data of serviceDetail; let i = index">
                <div *ngIf="data?.thumbnail">
                  <div class="bannerContent">
                    <div class="card innerDiv" (click)="dealVIEw(data?._id, data?.dealName)">
                      <div class="image img image-relative">
                        <div class="end-pro-time1 text-center mb-2" *ngIf="getCountDownOld(i, data?.dealEndTime)">
                          {{ getCountDownOld(i, data?.dealEndTime) }}
                        </div>
                        <img class="" [hidden]="!data?.isLoaded" (load)="onImageLaod(data)" [src]="data?.thumbnail"
                          loading="lazy" decoding="async" alt="categoryImage" />
                        <ngx-skeleton-loader *ngIf="!data?.isLoaded" [theme]="{
                          width: '100%',
                          height: '100%',
                          position: 'relative'
                        }" count="1"></ngx-skeleton-loader>
                      </div>
                      <div class="mt-3" style="max-width: 230px">
                        <p class="description">
                          {{ commonService.splitString(data?.dealName) }}
                        </p>
                      </div>
                      <div class="price-row">
                        <div class="row">
                          <div class="col-12 p-0 m-0">
                            <p class="price">
                              <span class="strikethrough">
                                {{
                                data?.dealDetails[0]?.price &&
                                getPrice(
                                data?.dealDetails[0]?.price
                                | currency : "ZAR" : "R"
                                )
                                }}
                              </span>
                              <span class="price-color">{{
                                data?.dealDetails[0]?.dealPrice &&
                                getPrice(
                                data?.dealDetails[0]?.dealPrice
                                | currency : "ZAR" : "R"
                                )
                                }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="row price-row">
                          <div class="col-12 p-0 m-0">
                            <p class="dealPrice">
                              <!-- Deal Discount : -->
                              <span class="newn">
                                {{ data?.dealDiscount }}% off
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!data?.thumbnail">
                  <div class="bannerContent d-flex justify-content-between">
                    <ngx-skeleton-loader *ngFor="let item of length(5)" [theme]="{
                      width: '227px',
                      height: '329px',
                      position: 'relative',
                      margin: '0 10px 0px 0px'
                    }" count="1">
                    </ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- service slider -->
      <div class="container productBox pb-3 bookingcategory" *ngIf="serviceData?.length" style="padding-top: 40px">
        <div class="d-flex justify-content-between heading-wrap" class="heading-wrap-centered">
          <h1 class="heading-text-cat">
            <!-- <img src="assets/latest/left-arrow.svg" alt="" class="leftImage" /> -->
            SERVICES
            <!-- <img src="assets/latest/right-arrow.svg" alt="" class="rightImage" /> -->
          </h1>
          <span routerLink="/customer-service-list" style="cursor: pointer">
            <p class="see-All">See All</p>
          </span>
        </div>
        <!-- <p class="service-para">Render Our Bookings At Your Doorsteps</p> -->
        <div class="items mt-4">
          <div class="slick_slider">
            <div class="service_slider slider slider-customize">
              <div *ngFor="let data of serviceData; let i = index">
                <div *ngIf="data?.categoryImage">
                  <div class="bannerContent bannerContent1">
                    <div class="card innerDiv newService" (click)="
                      navigateToViewService(
                        data?._id,
                        data?.categoryName,
                        data?.description
                      )
                    ">
                      <div class="image">
                        <img class="bannerSlideIamge" [hidden]="!data?.isLoaded" (load)="onImageLaod(data)"
                          [src]="data?.categoryImage" loading="lazy" decoding="async" alt="categoryImage" />
                        <ngx-skeleton-loader *ngIf="!data?.isLoaded" [theme]="{
                          width: '100%',
                          height: '402px',
                          position: 'relative',
                          margin: '0 10px 0px 0px'
                        }" count="1"></ngx-skeleton-loader>
                      </div>
                      <div class="mt-3">
                        <p class="description m-0">
                          {{ commonService.splitString(data?.categoryName) }}
                        </p>
                      </div>
                      <div class="mt-1">
                        <p class="description-text">
                          {{ data?.description | slice : 0 : 200 }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!data?.categoryImage">
                  <div class="bannerContent d-flex justify-content-between">
                    <ngx-skeleton-loader *ngFor="let item of length(3)" [theme]="{ width: '350px', height: '350px' }"
                      count="1"></ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ------------------------------------------third section Let's Get Started--------------------------- -->
      <!-- deal slider -->
      <div class="container pb-3 productBox" *ngIf="serviceDetailDeals?.length">
        <div class="d-flex justify-content-between" class="heading-wrap-centered">
          <h1 class="heading-text-cat">
            <!-- <img src="assets/latest/left-arrow.svg" alt="" /> -->
            DEALS ON BOOKINGS
            <!-- <img src="assets/latest/right-arrow.svg" alt="" /> -->
          </h1>
          <span routerLink="/customer-service-deal-list" style="cursor: pointer">
            <p class="see-All">See All</p>
          </span>
        </div>
        <div class="items mt-4">
          <div class="slick_slider">
            <div class="deal_slider_bookings slider slider-customize">
              <div *ngFor="let data of serviceDetailDeals; let i = index">
                <div *ngIf="data?.dealImage">
                  <div class="bannerContent">
                    <div class="card innerDiv" (click)="dealVIEwNew(data)">
                      <div class="image">
                        <img class="img" [hidden]="!data?.isLoaded" (load)="onImageLaod(data)"
                          [src]="data?.dealImage[0]" loading="lazy" decoding="async" alt="categoryImage" />
                        <ngx-skeleton-loader *ngIf="!data?.isLoaded" [theme]="{
                          width: '227px',
                          height: '329px',
                          position: 'relative',
                          margin: '0 10px 0px 0px'
                        }" count="1"></ngx-skeleton-loader>
                      </div>
                      <div class="mt-3">
                        <p class="description">
                          {{
                          commonService.splitString(
                          data?.serviceId?.serviceName
                          )
                          }}
                        </p>
                      </div>
                      <div class="price-row">
                        <div class="row">
                          <div class="col-12 p-0 m-0">
                            <p class="price">
                              <span class="strikethrough">
                                {{
                                data?.serviceId?.price &&
                                getPrice(
                                data?.serviceId?.price
                                | currency : "ZAR" : "R"
                                )
                                }}
                              </span>
                              <span class="price-color">{{
                                data?.dealPrice &&
                                getPrice(
                                data?.dealPrice | currency : "ZAR" : "R"
                                )
                                }}</span>
                            </p>
                          </div>
                        </div>
                        <div *ngIf="
                          getPercentage(data?.dealPrice, data?.serviceId?.price)
                        " class="row price-row">
                          <div class="col-12 p-0 m-0">
                            <p class="dealPrice">
                              <!-- Deal Discount : -->
                              <span class="newn">
                                {{
                                getPercentage(
                                data?.dealPrice,
                                data?.serviceId?.price
                                )
                                }}% off
                              </span>
                            </p>
                          </div>
                          <div class="end-pro-time text-center mb-2" *ngIf="getCountDown(i)">
                            <span class="countdown-timer">{{
                              getCountDown(i)
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!data?.dealImage">
                  <div class="bannerContent d-flex justify-content-between">
                    <ngx-skeleton-loader *ngFor="let item of length(5)" [theme]="{
                      width: '227px',
                      height: '329px',
                      position: 'relative',
                      margin: '0 10px 0px 0px'
                    }" count="1"></ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content ggg">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="d-flex justify-content-center mt-5 mb-4" id="book">
              <img class="for-img1" style="height: 100%" src="assets/images/book.png" alt="login form"
                class="img-fluid" />
            </div>
            <h2 class="modal-title d-flex justify-content-center" style="color: #ee3147">
              "Thanks for connecting with us."
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>